window.addEventListener('load', function () {
            if (window.innerWidth > 1025) {
              document.querySelectorAll('.home-services-sec .link.animate-arrow').forEach(function (el) {
                el.classList.add('button', 'button--primary');
              });
            }
          });


/*check contact form and newsletter success*/
document.addEventListener("DOMContentLoaded", function () {
const hash = window.location.hash; // e.g. "#anyid"
if (hash) {
const id = hash.substring(1); // Remove the #
const targetEl = document.getElementById(id);

if (targetEl) {

    const parentSection = targetEl.closest('.cm_tabs_section_item');
    

    if (parentSection) {
      const sectionClass = parentSection.getAttribute('data-section-class-fortab');

      // check if attribute exists and is not empty
      if (sectionClass && sectionClass.trim() !== '') {
        const tabButton = document.querySelector(`.cm_tabs_button[data-target="${sectionClass}"]`);

        if (tabButton) {
          tabButton.click(); // trigger click
        }
      }
    }




    const errorEl = targetEl.querySelector(".thisform_errors");
    const successEl = targetEl.querySelector(".thisform_success");

    if (errorEl) {
    errorEl.style.display = "block";
    }
    if (successEl) {
    successEl.style.display = "block";
    }

    // check section trigger service page
    const sectionService = document.querySelector('.cosma-service-box');
    if(sectionService){
      
       const menulink = document.querySelector(`.sub-menu-lists [href*="${id}"]`);

        if (menulink) {
          setTimeout(function() {
              menulink.click(); // trigger click after 1.5s
            }, 2000);

        }

    }
}
}
});










// cart drawer
$(document).on('click', 'cart-drawer .addon-remove', function (e) {
  e.preventDefault();

  const key = $(this).data('key');
  const $tr = $(this).closest('tr');
    var $thiscontainer=document.querySelector('cart-drawer');
    $tr.find('.cart-item__totals .loading-overlay').removeClass("hidden");

  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({
      id: key,   // remove by key
      quantity: 0,
      sections: getSectionsToRendercustom("drawer").map((section) => section.section),
      sections_url: window.location.pathname
    }),
    success: function (data) {
    const parsedState = data;
    //    setTimeout(function () {
    //         location.reload(); // refresh cart page after 500ms
    //     }, 2000);
    $thiscontainer.renderContents(parsedState,$tr);
    },
    error: function (xhr, status, error) {
      console.error('Error removing item:', error);
    }
  });
});



$(document).on('click', 'cart-drawer .main-remove-custom', function (e) {
  e.preventDefault();
    var $thiscontainer=document.querySelector('cart-drawer');

  let $this = $(this);
  let $tr = $this.closest('tr');
  let updates = {};
    $tr.find('.cart-item__totals .loading-overlay').removeClass("hidden");
  // Collect all addon keys inside this row
  $tr.find('.addon-remove').each(function () {
    let key = $(this).data('key');
    if (key) {
      updates[key] = 0; // mark for removal
    }
  });
 // Also remove the main product itself (this tr item)
  let mainKey = $tr.find('.main-remove-custom').data('key');
  if (mainKey) {
    updates[mainKey] = 0;
  }
  // Send bulk update
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({ updates: updates ,
      sections: getSectionsToRendercustom("drawer").map((section) => section.section),
      sections_url: window.location.pathname}),
    success: function (data) {
        const parsedState = data;
        //    setTimeout(function () {
        //         location.reload(); // refresh cart page after 500ms
        //     }, 2000);
        $thiscontainer.renderContents(parsedState,$tr);
        var $thiscartItems=document.querySelector('cart-drawer-items');

        if($thiscartItems.classList.contains("is-empty")){
            $thiscontainer.classList.add("is-empty");
        }
    },
    error: function (xhr, status, error) {
      console.error('Error removing bundle:', error);
    }
  });
});







//CartPage
$(document).on('click', 'cart-items .addon-remove', function (e) {
  e.preventDefault();

  const key = $(this).data('key');
  const $tr = $(this).closest('tr');
    var $thiscontainer=document.querySelector('cart-items');
    $tr.find('.cart-item__totals .loading-overlay').removeClass("hidden");

  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({
      id: key,   // remove by key
      quantity: 0,
      sections: getSectionsToRendercustom().map((section) => section.section),
      sections_url: window.location.pathname
    }),
    success: function (data) {
    const parsedState = data;
      console.log('Item removed:', data);
    //    setTimeout(function () {
    //         location.reload(); // refresh cart page after 500ms
    //     }, 2000);
    $thiscontainer.customDevUpdates(parsedState,$tr);
    },
    error: function (xhr, status, error) {
      console.error('Error removing item:', error);
    }
  });
});


$(document).on('click', 'cart-items .main-remove-custom', function (e) {
  e.preventDefault();
    var $thiscontainer=document.querySelector('cart-items');

  let $this = $(this);
  let $tr = $this.closest('tr');
  let updates = {};
    $tr.find('.cart-item__totals .loading-overlay').removeClass("hidden");
  // Collect all addon keys inside this row
  $tr.find('.addon-remove').each(function () {
    let key = $(this).data('key');
    if (key) {
      updates[key] = 0; // mark for removal
    }
  });
 // Also remove the main product itself (this tr item)
  let mainKey = $tr.find('.main-remove-custom').data('key');
  if (mainKey) {
    updates[mainKey] = 0;
  }
  // Send bulk update
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({ updates: updates ,
      sections: getSectionsToRendercustom().map((section) => section.section),
      sections_url: window.location.pathname}),
    success: function (data) {
     const parsedState = data;
     console.log('Item removed:', data);
        //    setTimeout(function () {
        //         location.reload(); // refresh cart page after 500ms
        //     }, 2000);
         $thiscontainer.customDevUpdates(parsedState);
     
    },
    error: function (xhr, status, error) {
      console.error('Error removing bundle:', error);
    }
  });
});


 function getSectionsToRendercustom(carttype) {
    if(carttype=="drawer"){
        return [
        {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
        },
        {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
        }
        ];
    }
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }